import { render, staticRenderFns } from "./ShareButton.vue?vue&type=template&id=b0fc8d00&scoped=true&"
import script from "./ShareButton.vue?vue&type=script&lang=js&"
export * from "./ShareButton.vue?vue&type=script&lang=js&"
import style0 from "./ShareButton.vue?vue&type=style&index=0&id=b0fc8d00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fc8d00",
  null
  
)

export default component.exports